export interface PersonaOverrideIds {
  devPersonaId?: string;
  localPersonaId?: string;
  all: string[];
}

function cleanId(id: unknown): string | undefined {
  if (typeof id !== 'string') return undefined;
  const trimmed = id.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

/**
 * Returns trimmed environment override persona IDs (devPersonaId and localPersonaId),
 * with backward-compatible support for snake_case aliases.
 */
export function getPersonaOverrideIds(persona: unknown): PersonaOverrideIds {
  if (!persona || typeof persona !== 'object') {
    return { all: [] };
  }
  const record = persona as Record<string, unknown>;
  const devPersonaId = cleanId(record.devPersonaId) ?? cleanId(record.dev_persona_id);
  const localPersonaId = cleanId(record.localPersonaId) ?? cleanId(record.local_persona_id);

  const all: string[] = [];
  if (devPersonaId) all.push(devPersonaId);
  if (localPersonaId && localPersonaId !== devPersonaId) all.push(localPersonaId);

  return {
    devPersonaId,
    localPersonaId,
    all,
  };
}
